import { NAV } from '@/stores/navigation';
import type { CommandAction } from '@/stores/commandPalette';

function go(path: string, newWindow = false) {
  if (newWindow) {
    window.open(path, '_blank', 'noopener,noreferrer');
    return;
  }
  history.pushState(null, '', path);
  dispatchEvent(new PopStateEvent('popstate'));
}

/** One action per section and one per section view ("Creativos · Ganchos"). */
export function buildNavigationActions(): CommandAction[] {
  return NAV.flatMap((group) =>
    group.items.flatMap((item) => [
      {
        id: `nav:${item.id}`,
        label: item.label,
        hint: item.openInNewWindow
          ? `Abrir ${item.label} en una ventana nueva`
          : `Ir a ${item.label}`,
        icon: item.icon,
        group: 'Ir a',
        keywords: [item.label.toLowerCase(), item.path.replace(/\//g, ' ').trim()],
        perform: () => go(item.path, item.openInNewWindow),
      },
      ...(item.tabs ?? [])
        .filter((tab) => tab.path !== item.path)
        .map((tab) => ({
          id: `nav:${item.id}:${tab.id}`,
          label: `${item.label} · ${tab.label}`,
          hint: `Ir a ${tab.label}`,
          icon: item.icon,
          group: 'Ir a',
          keywords: [
            tab.label.toLowerCase(),
            item.label.toLowerCase(),
            tab.path.replace(/\//g, ' ').trim(),
          ],
          perform: () => go(tab.path),
        })),
    ]),
  );
}
